import { isString } from 'formik';

import { useEditor } from './useEditor';

export const useFindAncestorWithType = (
  nodeId: string | undefined,
  nodeAncestorType?: string | string[],
) => {
  const { query } = useEditor();
  if (!nodeId || !nodeAncestorType) {
    return undefined;
  }

  let nodeAncestorResolvedType: string[] = nodeAncestorType as string[];
  if (isString(nodeAncestorType)) {
    nodeAncestorResolvedType = [nodeAncestorType];
  }

  const selectedNode = query.node(nodeId)?.get();
  if (!selectedNode) {
    return undefined;
  }

  return selectedNode?.data?.name === nodeAncestorType
    ? selectedNode.id
    : query
        .node(nodeId)
        ?.ancestors(true)
        ?.find((n) => nodeAncestorResolvedType.indexOf(query.node(n)?.get()?.data?.name) >= 0);
};
